const playoutDataCache = /* @__PURE__ */new Map();
export {
  playoutDataCache };
//# sourceMappingURL=dist/components/CoreVideoPlayer/playoutDataCache.js.map